import { ProjectType } from '@/types';

export const ProjectTypesData: Record<ProjectType, { name: ProjectType; labelEn: string; labelPt: string }> = {
  [ProjectType.ACADEMICAL]: {
    name: ProjectType.ACADEMICAL,
    labelEn: 'Academical',
    labelPt: 'Académico',
  },
  [ProjectType.FREELANCE]: {
    name: ProjectType.FREELANCE,
    labelEn: 'Freelance',
    labelPt: 'Freelance',
  },
  [ProjectType.PROFESSIONAL]: {
    name: ProjectType.PROFESSIONAL,
    labelEn: 'Professional',
    labelPt: 'Profissional',
  },
};


